import { authConfig } from "@istari-frontend/auth";
import { getEnv } from "@istari-frontend/shared";

import { isIdentityServiceEnabled } from "~/utils/identity-service";

import createService from "./createService";

const identityServiceEnabled = isIdentityServiceEnabled();
const zitadelAuthority = getEnv("VITE_ZITADEL_AUTHORITY");
const identityServiceAuthority = authConfig.authority;

export const adminServiceV1 = createService({
  url: identityServiceEnabled ? `${identityServiceAuthority}/api/v1` : `${zitadelAuthority}/management/v1`,
});

export const adminServiceV2 = createService({
  url: identityServiceEnabled ? `${identityServiceAuthority}/api/v1` : `${zitadelAuthority}/v2`,
});

export const authService = createService({
  url: `${authConfig.authority}/oauth/v2`,
});

export const profileService = createService({
  url: identityServiceEnabled ? `${identityServiceAuthority}/api/v1` : `${zitadelAuthority}/auth/v1`,
});
